import React, { useEffect, useState } from 'react';
import api from '../api';

const empty = { name: '', contact_name: '', phone: '', email: '', address: '', default_ship_to_address: '', notes: '' };

export default function Customers() {
  const [list, setList] = useState([]);
  const [search, setSearch] = useState('');
  const [sel, setSel] = useState(null);
  const [adding, setAdding] = useState(false);

  const load = () => api.get('/api/customers').then(r => setList(r.data || []));
  useEffect(() => { load(); }, []);

  const filtered = list.filter(c => !search || `${c.name} ${c.contact_name}`.toLowerCase().includes(search.toLowerCase()));

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
        <h2 style={{ flex: 1 }}>Customers</h2>
        <button className="btn-success" onClick={() => setAdding(true)}>+ Add Customer</button>
      </div>
      <input placeholder="Search customers…" value={search} onChange={e => setSearch(e.target.value)} style={{ marginBottom: 16 }} />
      <div className="cust-grid">
        {filtered.map(c => (
          <div key={c.id} className="card" style={{ cursor: 'pointer' }} onClick={() => setSel(c)}>
            <h3 style={{ margin: '0 0 8px' }}>{c.name}</h3>
            <div style={{ color: '#555', fontSize: 14 }}>{c.contact_name}</div>
            <div style={{ color: '#555', fontSize: 14 }}>{c.phone}</div>
            <div style={{ color: '#555', fontSize: 14 }}>{c.email}</div>
          </div>
        ))}
      </div>
      {sel && <CustomerModal cust={sel} onClose={() => setSel(null)} onSaved={() => { load(); setSel(null); }} />}
      {adding && <CustomerModal cust={empty} isNew onClose={() => setAdding(false)} onSaved={() => { load(); setAdding(false); }} />}
    </div>
  );
}

function CustomerModal({ cust, isNew, onClose, onSaved }) {
  const [form, setForm] = useState(cust);
  const upd = (k, v) => setForm(f => ({ ...f, [k]: v }));
  const save = async () => {
    if (isNew) await api.post('/api/customers', form);
    else await api.put(`/api/customers/${cust.id}`, form);
    onSaved();
  };
  return (
    <div className="modal-bg" onClick={onClose}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <h3 style={{ marginTop: 0 }}>{isNew ? 'Add Customer' : form.name}</h3>
        <div className="field"><label>Company Name</label><input value={form.name || ''} onChange={e => upd('name', e.target.value)} /></div>
        <div className="grid2">
          <div className="field"><label>Contact</label><input value={form.contact_name || ''} onChange={e => upd('contact_name', e.target.value)} /></div>
          <div className="field"><label>Phone</label><input value={form.phone || ''} onChange={e => upd('phone', e.target.value)} /></div>
          <div className="field"><label>Email</label><input value={form.email || ''} onChange={e => upd('email', e.target.value)} /></div>
          <div className="field"><label>Address (Sold To)</label><input value={form.address || ''} onChange={e => upd('address', e.target.value)} /></div>
        </div>
        <div className="field">
          <label>Default Ship-To Address (optional)</label>
          <textarea
            rows={2}
            value={form.default_ship_to_address || ''}
            onChange={e => upd('default_ship_to_address', e.target.value)}
            placeholder="Leave blank to use the Sold-To address on BOLs"
          />
        </div>
        <div className="field"><label>Notes</label><textarea value={form.notes || ''} onChange={e => upd('notes', e.target.value)} /></div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button className="btn-success" onClick={save}>Save</button>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
